module.exports = __webpack_public_path__ + "img/75573.d0f6973d.svg";